import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const authToken = localStorage.getItem("authToken");
  const userRole = localStorage.getItem("userRole");

  // Check authentication
  const isAuthenticated = !!authToken && !!userRole;
  console.log(authToken,userRole);
  console.log(!!authToken);
  
  

  // Check role
  const isAuthorized = allowedRoles ? allowedRoles.includes(userRole) : true;

  // Redirects
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!isAuthorized) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;